import styled from 'styled-components';
import React, { useHistory, useLocation, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { _ } from '_locales';
import { connect } from 'react-redux';
import { eventTracker } from '_helpers';
import { Container, LinkButton } from '../Quiz/styles';
import { Button } from '../Education/components';
import events from '../Education/events';

const Title = styled.h1`
  margin-bottom: 10px;
  text-align: center;
`;

const Score = styled.h1`
  text-align: center;
  margin-bottom: 15px;
`;

const BadgeContainer = styled.div`
  padding: 40px 40px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const BadgeImage = styled.div`
  width: 220px;
  height: 220px;
  background-image: url('${({ src }) => src}');
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  margin: 30px auto;
  justify-content: center;
  width: 400px;
`;

const QuizFeedback = ({
  quizState,
}) => {
  const { state } = useLocation();
  const { type = 'rf' } = useParams();

  const quizType = {
    rf: {
      quiz: 'rfQuiz',
      data: 'recyclingFundamentals',
      success: 'hasPassedRfQuiz',
      badgePath: 'https://cdn.recyclecoach.com/app-badges/fundamentals.png',
      interactionQuizKey: 'DID_PASS_RF_QUIZ',
      landEvent: events.DZ_RF_QUIZ_FEEDBACK_LAND,
      successBadge: 'Fundamentals',
      viewIncorrectAnswers: 'DZ_RF_QUIZ_FEEDBACK_VIEW_INCORRECT_ANSWERS_TAP'
    },
    mum: {
      quiz: 'mumQuiz',
      data: 'misundestoodMaterials',
      success: 'hasPassedMmQuiz',
      badgePath: 'https://cdn.recyclecoach.com/app-badges/misunderstood.png',
      interactionQuizKey: 'DID_PASS_MM_QUIZ',
      landEvent: events.DZ_MM_QUIZ_FEEDBACK_LAND,
      successBadge: 'Misunderstood',
      viewIncorrectAnswers: 'DZ_MM_QUIZ_FEEDBACK_VIEW_INCORRECT_ANSWERS_TAP'
    }
  };

  const { replace } = useHistory();
  const quizes = state?.isLearningModule ? quizState[quizType[type].quiz][state.lmIndex]
    : quizState[quizType[type].quiz];

  const successfulItems = Object
    .keys(quizes)
    .filter((key) => quizes[key].passed);
  const total = Object.keys(quizes).length;

  const totalPasses = successfulItems.length;
  const didPassTheQuiz = totalPasses >= total - 1;
  const badgeIconPath = quizType[type].badgePath;
  const title = didPassTheQuiz ? _('education.success') : _('education.so_close');
  const description = didPassTheQuiz ? `${_('education.congratulation')}, ${_('education.you_earned', {
    badge: quizType[type].successBadge,
    // eslint-disable-next-line no-nested-ternary
    lesson_type: (type === 'rf') ? _('education.recycling_fundamentals') : (type === 'lm') ? _('education.learning_modules') : _('education.misunderstood_materials')
  })}` : _('education.what_they_do_next');

  const showResults = () => {
    replace(`/quiz-results/${type}`, {
      lmIndex: state?.lmIndex,
      isLearningModule: state?.isLearningModule
    });
  };

  const haveAtLeastOneMistake = Object
    .keys(quizes)
    .map((key) => quizes[key])
    .some(({ failed }) => failed);

  useEffect(() => {
    eventTracker(quizType[type].landEvent, { passed: didPassTheQuiz });
  }, [type, didPassTheQuiz]);

  return (
    <div>
      <Container>
        <BadgeContainer>
          <BadgeImage
            src={badgeIconPath}
          />
        </BadgeContainer>
        <Title>
          {title}
        </Title>
        <Score>
          {successfulItems.length}
          /
          {total}
        </Score>
        {/* <Body>
          {description}
        </Body> */}
        <ButtonContainer>
          {haveAtLeastOneMistake ? (
            <Button
              style={{ flex: 1 }}
              onClick={() => {
                eventTracker(quizType[type].viewIncorrectAnswers, { passed: didPassTheQuiz });
                showResults();
              }}
            >
              {_('education.view_incorrect_answers')}
            </Button>
          ) : null}
          {didPassTheQuiz ? (
            <Button
              style={{ flex: 1 }}
              className="btn outline royal"
              onClick={() => replace('/education')}
            >
              {_('education.close')}
            </Button>
          ) : null}
        </ButtonContainer>
      </Container>
    </div>
  );
};

const mapStateToProps = (state) => ({
  quizData: state.quiz.quizData,
  quizState: state.quiz.quizState,
});

export default connect(mapStateToProps, null)(QuizFeedback);
